export const build = {"tag":"v1.0.4","hash":"ccfdbbaa","time":"260928.0926"}